/**
 * Onboarding API client — consumed by /onboarding/org (G5).
 * Backend at /api/onboarding/me/* (apps/organizations/views_onboarding.py).
 */
import api from "./axios";

export const getOnboardingProgress = () =>
  api.get("/api/onboarding/me/");

export const updateOnboardingProgress = (data) =>
  api.patch("/api/onboarding/me/", data);

export const listVerificationDocs = () =>
  api.get("/api/onboarding/me/documents/");

export const uploadVerificationDoc = (file, docType, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  form.append("doc_type", docType);
  return api.post("/api/onboarding/me/documents/", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: onProgress,
  });
};

export const inviteTeammate = (email, role = "USER") =>
  api.post("/api/onboarding/me/invite-teammate/", { email, role });

export const requestArchiveAccess = (note) =>
  api.post("/api/onboarding/me/request-archive/", { note });
